/**
 * Environment-driven copy for survey chrome (advocate name, etc.).
 * @agentic members
 */

/**
 * Advocate name shown in footers and next steps; falls back to generic care team.
 * @agentic members
 */
export const getAdvocateDisplayName = (): string =>
  import.meta.env["VITE_SURVEY_ADVOCATE_NAME"] ?? "Your care team";
